/**
 * TITAM AI - Componentes de Métricas
 * Cards de métricas com formatação e trend
 */

import Icon from './icons.jsx'
import { fmtByFormat } from '../lib/format.js'

/**
 * MetricCard - Card de métrica individual
 */
export function MetricCard({ label, value, format = 'number', trend, sublabel = 'vs período anterior' }) {
  const formatValue = () => fmtByFormat(value, format)

  return (
    <div className="metric-card-compact">
      <div className="metric-card-header">
        <span className="metric-card-label">{label}</span>
        {trend !== undefined && (
          <span className={`metric-card-trend ${trend >= 0 ? 'up' : 'down'}`}>
            <Icon n={trend >= 0 ? 'trend_up' : 'trend_down'} s={10} />
            {Math.abs(trend).toFixed(1)}%
          </span>
        )}
      </div>
      <div className="metric-card-value">{formatValue()}</div>
      {sublabel && <div className="metric-card-subtitle">{sublabel}</div>}
    </div>
  )
}

/**
 * MetricFunnel - Cards em estrutura contínua de funil (visual do Funil Orgânico),
 * organizados em linhas. `rows` é um array de linhas; cada linha um array de
 * { label, value, format }.
 */
function fmtFunnel(value, format) {
  return fmtByFormat(value, format)
}

export function MetricFunnel({ rows = [] }) {
  return (
    <div className="ga-funnel">
      {rows.map((row, ri) => (
        <div key={ri} className="ga-funnel-row">
          {row.map((cell) => {
            const isRate = cell.format === 'percent'
            return (
              <div
                key={cell.label}
                className={`ga-funnel-cell${isRate ? ' ga-funnel-cell--rate' : ''}`}
                title={cell.label}
              >
                <span className="ga-funnel-cell-label" title={cell.label}>{cell.label}</span>
                <span className="ga-funnel-cell-value">{fmtFunnel(cell.value, cell.format)}</span>
                {cell.sub && (
                  <span
                    className="ga-funnel-cell-sub"
                    title={`${cell.sub.label}: ${fmtFunnel(cell.sub.value, cell.sub.format)}`}
                  >
                    {cell.sub.label}: {fmtFunnel(cell.sub.value, cell.sub.format)}
                  </span>
                )}
              </div>
            )
          })}
        </div>
      ))}
    </div>
  )
}

/**
 * MetricGroup - Grupo de métricas relacionadas
 */
function MetricGroup({ title, metrics }) {
  return (
    <div className="metric-group">
      {title && <h4 className="metric-group-title">{title}</h4>}
      <div className="metric-group-grid">
        {metrics.map((m, i) => (
          <MetricCard key={i} {...m} />
        ))}
      </div>
    </div>
  )
}

/**
 * MetricTrend - Indicador de tendência simples
 */
function MetricTrend({ value, positive = true, suffix = '%' }) {
  return (
    <span className={`metric-trend ${positive ? 'positive' : 'negative'}`}>
      <Icon n={positive ? 'trend_up' : 'trend_down'} s={12} />
      {Math.abs(value).toFixed(1)}{suffix}
    </span>
  )
}

/**
 * MetricHighlight - Métrica em destaque grande
 */
function MetricHighlight({ label, value, format = 'number', trend, description }) {
  const formatValue = () => fmtByFormat(value, format)

  return (
    <div className="metric-highlight">
      <span className="metric-highlight-label">{label}</span>
      <span className="metric-highlight-value">{formatValue()}</span>
      {trend !== undefined && (
        <span className={`metric-highlight-trend ${trend >= 0 ? 'up' : 'down'}`}>
          <Icon n={trend >= 0 ? 'arrow_up' : 'arrow_down'} s={14} />
          {Math.abs(trend).toFixed(1)}%
        </span>
      )}
      {description && <p className="metric-highlight-desc">{description}</p>}
    </div>
  )
}
